import Tracked from '~/components/Tracked';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import { SelectedView } from './index';

type Props = {
  selectedView: SelectedView;
  setSelectedView: React.Dispatch<React.SetStateAction<SelectedView>>;
};

export default function ViewToggle({ selectedView, setSelectedView }: Props) {
  const { RAFFLES, RETAILERS } = SelectedView;

  return (
    <div className="flex gap-2 mb-2">
      <Toggle
        isSelected={selectedView === RETAILERS}
        onClick={() => setSelectedView(RETAILERS)}
        name="WTB_VIEW_TOGGLE_RETAILERS"
      >
        Retailers
      </Toggle>
      <Toggle
        isSelected={selectedView === RAFFLES}
        onClick={() => setSelectedView(RAFFLES)}
        name="WTB_VIEW_TOGGLE_RAFFLES"
      >
        Raffles
      </Toggle>
    </div>
  );
}

function Toggle({
  onClick,
  children,
  isSelected,
  name
}: {
  children: React.ReactNode;
  isSelected: boolean;
  name: TrackedButtonClickName;
  onClick: () => void;
}) {
  return (
    <Tracked.Button
      onClick={onClick}
      className={`!rounded-full ${isSelected ? 'bg-black text-white' : ''}`}
      pagePosition="WTB"
      name={name}
      variant={
        isSelected ? 'transparent-black-border' : 'transparent-grey-border'
      }
    >
      <p className="flex items-center justify-center gap-1 font-light text-xs p-0.5">
        {children}
      </p>
    </Tracked.Button>
  );
}
